import React from "react";
import { createRef } from "react";
import { Modal, FormControl, Col, Form, FormGroup, InputGroup, Button } from "react-bootstrap";
import i18n from "i18next";
import PropTypes from "prop-types";

export default class SearchComponent extends React.Component {
  constructor(props) {
    super(props);
    this.queryRef = createRef();
  }

  render() {
    return (
      <InputGroup className="searchInputTopBar">
        <FormControl
          onChange={this.props.onChange}
          autoFocus
          ref={this.queryRef}
          type="text"
          disabled={this.props.disabled}
        />
        <InputGroup.Text
          className="inputSearch"
          onClick={(e) => {
            this.props.onSearch(this.queryRef.current.value);
            e.preventDefault();
          }}
          style={{ cursor: "pointer" }}
        >
          🔍 {i18n.t("FileModal.APIProviders.search")}
        </InputGroup.Text>
      </InputGroup>
    );
  }
}
SearchComponent.propTypes = {
  /**
   * Function called when the user clicks the search button
   */
  onSearch: PropTypes.func,
  /**
   * Function called when the user types on the search box
   */
  onChange: PropTypes.func,
  /**
   * Input disabled
   */
  disabled: PropTypes.bool,
};
